<template>
  <Container type="card-full" v-loading = 'loading'>
    <div slot="header">
      <!-- <el-button @click="save" :loading="btnLoading" v-if="+radio===2 && type === 1">保存</el-button>
      <vxe-button v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="">{{btn.btnname}}</vxe-button> -->
      <el-button @click="toSeeCJTZX" type='primary'>查看成交通知书</el-button>
    </div>
    <div>
      <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目编号</div>
              <div class="view-value"> {{psu.projectcode}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">平台编号</div>
              <div class="view-value"> {{psu.projectno}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">报名方式</div>
              <div class="view-value">{{+psu.projectisinvite === 1?'邀请':'公开'}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目名称</div>
              <div class="view-content"> {{psu.projectname}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">采购人</div>
              <div class="view-value"> {{psu.pcomfullname}}</div>
            </div>
          </div>
          <div class="split-box" v-if="+psu.psuconfirmfeeamt > 0">
              <div class="split-line"></div>
              <div class="split-name">【支付及开票信息】</div>
          </div>
          <div class="view-row" v-if="+psu.psuconfirmfeeamt > 0">
            <div class="view-field">
              <div class="view-label">单位名称</div>
              <div class="view-value">{{comlist.comfullname}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">信用代码</div>
              <div class="view-value">{{comlist.comidcode}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">纳税人类型</div>
              <div class="view-value">{{+comlist.comtaxtype === 1?'一般纳税人':(+comlist.comtaxtype === 2?'小规模纳税人':'')}}</div>
            </div>
          </div>
          <div class="view-row">
              <div class="view-field">
                <div class="view-label" style="line-height:40px;">报名电话</div>
                <div class="view-value">
                  {{psu.psucontactphone}}
                </div>
              </div>
              <div class="view-field">
                <div class="view-label" style="line-height:40px;">报名邮箱</div>
                <div class="view-value">
                  {{psu.psucontactmail}}
                </div>
              </div>
          </div>
          <div class="view-row" v-if="+psu.psuconfirmfeeamt > 0">
            <div class="view-field">
              <div class="view-label"><span style="color:red;">*</span>发票类型</div>
              <div class="view-con" v-if="+changeInfo === 2 || isShowFinvoice">
                  <el-radio-group v-model="fwfinvoice" @change="changefptype">
                    <el-radio :label="1">增值税普通发票(电子票)</el-radio>
                    <el-radio :label="2">增值税专用发票(电子票)</el-radio>
                  </el-radio-group>
              </div>
              <div class="view-value" v-else >
                {{+psu.psufwfinvoice === 1 ? '增值税普通发票':+psu.psufwfinvoice === 2?'增值税专用发票':'未填写'}}
              </div>
            </div>
          </div>
            <div class="view-row"  v-if="+psu.psuconfirmfeeamt > 0 && +fwfinvoice === 2">
              <div class="view-field">
                <div class="view-label" style="line-height:40px;">单位地址</div>
                <div class="view-value" v-if="+changeInfo===1 && !isShowFinvoice">
                  {{comlist.comaddr}}
                </div>
                <div class="view-value" v-else>
                  <el-input v-model="comlist.comaddr" placeholder="请输入单位地址" :maxlength="255" ></el-input>
                </div>
              </div>
              <div class="view-field">
                <div class="view-label" style="line-height:40px;">单位电话</div>
                <div class="view-value" v-if="+changeInfo===1 && !isShowFinvoice">
                  {{comlist.comtel}}
                </div>
                <div class="view-value" v-else>
                  <el-input v-model="comlist.comtel" placeholder="请输入单位电话" :maxlength="255" ></el-input>
                </div>
              </div>
            </div>
            <div class="view-row" v-if="+psu.psuconfirmfeeamt > 0 && +fwfinvoice === 2">
              <div class="view-field">
                <div class="view-label" style="line-height:40px;">开户银行</div>
                <div class="view-value" v-if="+changeInfo===1 && !isShowFinvoice">
                  {{comlist.combank}}
                </div>
                <div class="view-value" v-else>
                  <el-input v-model="comlist.combank" placeholder="请输入开户银行" :maxlength="255"></el-input>
                </div>
              </div>
              <div class="view-field">
                <div class="view-label" style="line-height:40px;">开户账号</div>
                <div class="view-value" v-if="+changeInfo===1 && !isShowFinvoice">
                  {{comlist.combanknumber}}
                </div>
                <div class="view-value" v-else>
                  <el-input v-model="comlist.combanknumber" placeholder="请输入开户账号" :maxlength="50"></el-input>
                </div>
              </div>
          </div>
          <div class="view-row" v-if="+psu.psuconfirmfeeamt > 0">
              <div class="view-field">
                <div class="view-label" style="line-height:40px;">申请备注</div>
                <div class="view-con" v-if="+changeInfo===1 && !isShowFinvoice" style="margin-top:10px;">
                  <div v-if="psu.psuInvoicmark">{{psu.psuInvoicmark}}</div>
                  <div v-else> {{msgCon}}</div>
                </div>
                <div class="view-con" v-else>
                    <el-input type="textarea" :placeholder="msgCon" :autosize="{ minRows: 2}"
                              v-model="psu.psuInvoicmark" :maxlength="50" show-word-limit></el-input>
                </div>
              </div>
          </div>
          <!-- <div class="view-row"  v-if="+psu.psuconfirmfeeamt > 0">
            <div class="view-field">
              <div class="view-label"></div>
              <div class="view-value">
                <el-button type='primary' @click="savekpxx" v-if="+changeInfo!==1">保存</el-button>
                <el-button type='primary' @click="changekhInfo" v-else>修改</el-button>
              </div>
            </div>
          </div> -->
          <!-- <div class="split-box">
            <div class="split-line"></div>
            <div class="split-name">【服务费支付】</div>
          </div> -->
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">费用金额</div>
              <div class="view-value">{{setThousand(psu.psuconfirmfeeamt)?'￥'+setThousand(psu.psuconfirmfeeamt):"服务费未确认"}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">支付状态</div>
              <div class="view-value">{{+psu.psufeepayflg === 1 ?'已支付':'未支付'}}</div>
            </div>
            <div class="view-field" v-if="+psu.psufeepayflg === 1 && +psu.psuconfirmfeeamt > 0">
              <div class="view-label">支付方式</div>
              <div class="view-value">{{Number(psu.psufeepaytype) === 3 ? '线下支付' : (Number(psu.psufeepaytype) === 1 ? '支付宝支付':'微信支付')}}</div>
            </div>
          </div>
          <!-- <div class="view-row"  v-if="+psu.psufeepayflg !== 1 && +psu.psuconfirmfeeamt > 0">
            <div class="view-field" v-if="+psu.projectfeepayway === 3">
              <div class="view-label">支付方式</div>
              <div class="view-value">
                <el-radio-group v-model="radio" class="value" required>
                  <el-radio :label="1">线上支付</el-radio>
                  <el-radio :label="3">线下支付</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div> -->
          <!-- <div class="view-row"  v-if="+psu.psufeepayflg !== 1 && +radio === 1">
            <div class="view-field">
              <div class="view-label"></div>
              <div class="view-groupbtn">
                  <el-button type='primary' @click="alipaypay" v-if="type === 1">
                    <i class="el-icon-my-zfb"></i>支付宝支付</el-button>
                  <el-button type='primary' @click="tenpay" v-if="type === 1">
                    <i class="el-icon-my-wechat"></i>微信支付</el-button>
              </div>
            </div>
          </div> -->
          <div class="view-row"  v-if="+psu.psufeepayflg !== 1">
            <div class="view-field">
              <div class="view-label">支付凭证</div>
              <div class="view-groupbtn">
                <div>
                    <upload-pic-one @changed='setfile' :picUrl='psu.psufeepayurl' folderName='web' text="选择图片"></upload-pic-one>
                </div>
              </div>
            </div>
          </div>
          <div class="view-row" v-if="+psu.psufeepayflg !== 1 || isShowFinvoice">
            <div class="view-field">
              <div class="view-label"></div>
              <div class="view-value">
                <vxe-button @click="save" :loading="btnLoading" type='primary'>保存</vxe-button>
              </div>
            </div>
          </div>
          <div class="view-row" v-if="+psu.psufeepayflg === 1">
              <div class="view-field" v-if="Number(psu.psufeepaytype) === 3 && psu.psufeepayurl">
                <div class="view-label">支付凭证</div>
                <div class="view-content">
                  <popover-img :img-src="psu.psufeepayurl ? uploadAddr + psu.psufeepayurl:''"
                               default-height="150"></popover-img>
                </div>
              </div>
              <div class="view-field" v-else-if="Number(psu.psufeepaytype) === 2 || Number(psu.psufeepaytype) === 1">
                <div class="view-label">交易号</div>
                <div class="view-value">{{psu.psufeepaytradeno}}</div>
              </div>
          </div>
          <div class="view-row" >
            <div class="view-field" v-if="psu.psufeepayuserid || psu.psufeecheckuserid">
              <div class="view-label">支付人</div>
              <div class="view-value">
                {{psu.psufeepayuserid?psu.psufeepayusername:psu.psufeecheckusername}}
              </div>
            </div>
            <div class="view-field" v-if="psu.psufeepaytradeno">
              <div class="view-label">交易单号</div>
              <div class="view-value">
                {{psu.psufeepaytradeno}}
              </div>
            </div>
            <div class="view-field" v-if="psu.psufeepaytime">
              <div class="view-label">支付时间</div>
              <div class="view-value">
                {{psu.psufeepaytime | newDate}}
              </div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field" v-if="+psu.psufewreceive===1 || +psu.psufewreceive===2">
              <div class="view-label">审查状态</div>
              <div class="view-value">{{+psu.psufewreceive===1?'已收':'未收'}}</div>
            </div>
            <div class="view-field" v-if="+psu.psufewreceive===1 || +psu.psufewreceive===2">
              <div class="view-label">审核时间</div>
              <div class="view-value">{{psu.psufewreceivetime | newDate}}</div>
            </div>
          </div>
          <div class="split-box">
              <div class="split-line"></div>
              <div class="split-name">【上传电子合同】<span style="color:red;">务必上传与采购人签订合同的电子文件，委托人在获取到该文件后退还保证金。</span></div>
          </div>
          <div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">电子合同</div>
                <div style="color: #2f74ff;cursor: pointer;"
                        @click="downFile(append.appendurl)" v-if="Appendcount > 0">
                      <a :src="$store.getters.uploadAddr + append.appendurl">{{append.appendfilename}}</a>
                </div>
                <div v-else>
                  <div>
                    <upload-btn @changed='setfileAppend' text="上传电子合同"></upload-btn>
                  </div>
                  <div v-if="append">
                    <div style="color: #2f74ff;cursor: pointer;"
                        @click="downFile(append.appendurl)" v-if="append.appendfilename">
                      <a :src="$store.getters.uploadAddr + append.appendurl">{{append.appendfilename}}</a>
                    </div>
                    <div v-if="append.appendfilename">
                      <el-button type='primary' @click="seveAppend" :loading="btnLoading" >保存</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="split-box">
              <div class="split-line"></div>
              <div class="split-name">【服务费发票】</div>
          </div>
          <div class="view-row"  v-if="psu.psuconfirmfeeamt > 0">
            <div class="view-field">
              <div class="view-label">开票</div>
              <div class="view-value">{{+psu.psufwfinvoiceflg === 2?'已开':'未开'}}</div>
            </div>
            <div class="view-field" v-if="+psu.psufwfinvoiceflg === 2">
              <div class="view-label">发票号</div>
              <div class="view-value">{{psu.psufwfinvoicenum}}</div>
            </div>
            <div class="view-field" v-if="+psu.psufwfinvoiceflg === 2">
              <div class="view-label">开票时间</div>
              <div class="view-value">{{psu.psufwfinvoicetime | newDate}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <paycommon :type="Paytype" :visible="visible" :order="order" @cacle="cacle">
      <div class="wxmessage">
        <div class="wxmessageItem">
          <div class="itemName">交易金额</div>
          <div class="itemPrice"><span class="priceText">{{psu.psuconfirmfeeamt}}</span>元</div>
        </div>
        <div class="wxmessageItem">
          <div class="itemName">支付方式</div>
          <div class="itemPrice">微信支付</div>
        </div>
        <div class="wxmessageItem">
          <div class="itemName">交易号</div>
          <div class="itemPrice">{{psu.projectcode}}</div>
        </div>
      </div>
    </paycommon>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadPicOne from '../common/uploadPicOne'
  import _ from 'lodash'
  import popoverImg from '../common/popoverImg'
  import dayjs from 'dayjs'
  import common from '@/mixin/common'
  import paycommon from  '../../components/core/paycommon'
  import uploadBtn from '../common/uploadBtn'
  export default {
    name: "psuServicepayForm",
    mixins: [common],
    data () {
      return {
        changeInfo:2,
        type: Number(this.$route.params.type),
        btnLoading: false,
        loading : false,
        psuid:this.$route.params.form.psuid,
        psu: {},
        fwfinvoice:0,
        userid : this.$store.getters.loginUser.userid,
        order: {
          outTradeNo: "",   //订单号
          productCode: 'FAST_INSTANT_TRADE_PAY',
          totalAmount: '',   //金额：微信单位（分），支付宝单位（元）
          subject: '',   //商品名
          body: '',   //商品信息
          passback_params: ''    //项目id_用户id_保证金0或者服务费1
        },
        visible:false,
        Paytype:0,
        radio:3,
        append: {},
        Appendcount:0,
        comlist:[],
        Interval:null
      }
    },
    activated () {
    },
    created(){
      this.init()
      this.getList()
      this.getAppend()
      this.getComInfo()
    },
    watch: {},
    filters:{
      newDate(value){
        return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
      },
      qfwVal(value) {
        return utils.comdify(value)
      }
    },
    components: {uploadPicOne,paycommon,popoverImg,uploadBtn},
    computed: {
      isShowFinvoice () {
        if (this.psu && !this.psu.psufwfinvoice) {
          return true
        } else {
          return false
        }
      },
      uploadAddr () {
        return this.$store.getters.uploadAddr
      },
      msgCon(){
        if(+this.fwfinvoice === 1){
          return '增值税普通发票将以电子发票发送到报名人邮箱。'
        } else {
          return '增值税专用发票将以电子发票发送到报名人邮箱。'
          // return '发票寄送地址与公司地址及收件人不一致，可填写收票地址，收件人。'
        }
      }
    },
    methods: {
      cacle (val) {
        this.visible = val
        clearInterval(this.Interval)
      },
      setThousand (value) {
        return utils.comdify(value)
      },
      btnClick (code) {
        this.$emit(code)
      },
      changekhInfo(){
        this.changeInfo = 2
      },
      //获取供应商单位信息
      async getComInfo(){
        let from = {}
        from.comid = this.$store.getters.loginUser.comid
        from.cosid = this.$store.getters.loginUser.cosid
        let data = await request({
          url: '/ywgl/com/getComById',
          method: "get",
          params: from
        })
        this.comlist = data[0]
      },
      changefptype(val){
        if(+val === 1){
          this.psu.projectfeepayway = 3
          this.radio = 1
        } else {
          this.psu.projectfeepayway = 2
          this.radio = 3
        }
      },
      async getList(){
        this.loading = true
        let data = await request({
            url: '/xmgl/project/getpsubyid',
            method: "get",
            params:{psuid : this.psuid}
        }).catch(() => {
          this.loading = false
        })
        if(+data[0].projectfeepayway === 1){
          this.radio = 1
        } else if(+data[0].projectfeepayway === 2){
          this.radio = 3
        }
        if((+data[0].psufeepaytype>0 && +data[0].psufeepayflg === 1)|| (+data[0].psufewreceive!=2 && +data[0].psufewreceive!=0)){
            this.changeInfo = 1
        }
        this.psu = data[0]
        this.fwfinvoice = this.psu.psufwfinvoice
        this.loading = false
      },
      async setfileAppend (path,filename) {
        this.append = {
            appendid: 0,
            appendfromid: this.$route.params.form.psuid,
            appendfromtype: 21,
            appendtype: '100',
            appendseq: 1,
            appendfilecode: '',
            appendfilename: filename,
            appendurl: path.replace(this.uploadAddr,'')
        }
      },
      async seveAppend(){
        this.$confirm(`请确保上传的单位合同准确无误，上传后将不能修改`, '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
          }).then(async () => {
              let res = await request({
                url:'ywgl/append/addOnlyOne',
                method: "post",
                data:this.append
              })
              if(+res.issuccess === 1){
                this.$message.success('保存成功')
                this.getAppend()
              }
          })
      },
      async savekpxx (){
          if(!this.fwfinvoice){
            this.$message.warning('请选择发票类型！')
            return
          }
          let from = {}
          from.psuid = this.psu.psuid
          from.psuInvoicmark = this.psu.psuInvoicmark
          from.fwfinvoice = this.fwfinvoice
          from.comtel = this.comlist.comtel
          from.comaddr = this.comlist.comaddr
          from.combank = this.comlist.combank
          from.combanknumber = this.comlist.combanknumber
          from.comid = this.comlist.comid
          let data = await request({
            url: '/xmgl/project/updatecom',
            method: "post",
            data: from
          })
          if (data.issuccess === 1) {
            this.getList()
            this.changeInfo = 1
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
      },
      async getAppend(){
          let res = await request({
            method:'get',
            url:'ywgl/append/getAppendListByFromId',
            params:{appendfromid:this.$route.params.form.psuid,appendfromtype:21}
          })
          this.Appendcount = res.length
          this.append = res[0]
      },
      async toSeeCJTZX(){
        if(+this.psu.psubcnflg === 1){
          this.$message.warning('通知书暂未制作完成，请耐心等候。')
          return
        }
        let {href} = this.$router.resolve({name: 'pjBiddingNotice', query: {psuid: this.$route.params.form.psuid,projectid: this.psu.projectid}})
        window.open(href, '_blank')

      },
      async init () {
        this.psuid = this.$route.params.form.psuid
        this.psu = {}
        this.append = {}
        this.userid = this.$store.getters.loginUser.userid
        this.btnLoading = false
        this.visible = false
      },
      async setfile (path) {
        this.psu.psufeepayurl = path.replace(this.uploadAddr, '')
      },
      async saveFinvoice () {
        if(!this.fwfinvoice){
          this.$message.warning('请选择发票类型！')
          return
        }
        this.loading = true
        let from = {}
        from.psuid = this.psu.psuid
        from.psuInvoicmark = this.psu.psuInvoicmark
        from.fwfinvoice = this.fwfinvoice
        from.comtel = this.comlist.comtel
        from.comaddr = this.comlist.comaddr
        from.combank = this.comlist.combank
        from.combanknumber = this.comlist.combanknumber
        from.comid = this.comlist.comid
        let data = await request({
          url: '/xmgl/project/savefinvoice',
          method: "post",
          data: {
            psuid: this.psu.psuid,
            from:from
          }
        })
        if (data.issuccess === 1) {
          await this.getComInfo()
          await this.getList()
          this.$message.success('开票信息保存成功')
          this.loading = false
        } else {
          this.loading = false
          this.$message.error('开票信息保存失败')
        }
      },
      async save () {
        if (this.isShowFinvoice && this.psu.psufeepayflg === 1) {
          await this.saveFinvoice()
          return 
        }
        if(!this.fwfinvoice){
          this.$message.warning('请选择发票类型！')
          return
        }
        // if(!this.comlist.comaddr && +this.fwfinvoice === 2){
        //   this.$message.warning('请填写单位地址！')
        //   return
        // }
        if(!this.psu.psuconfirmfeeuserid){
            this.$message.warning('服务费未确认！')
            return
        }
        if(+this.psu.psufeepayflg === 1){
          this.$message.warning('已支付')
          return
        }
        if(+this.psu.psuconfirmfeeamt > 0 && !this.psu.psufeepayurl){
          this.$message.warning('请上传支付凭证！')
          return
        }
        // if (+this.radio === 3) {
        //   this.psu.psufeepaytype = this.radio
        // } else {
        //   this.psu.psufeepaytype = this.Paytype
        // }
        this.loading = true
        let from = {}
        from.psuid = this.psu.psuid
        from.psuInvoicmark = this.psu.psuInvoicmark
        from.fwfinvoice = this.fwfinvoice
        from.comtel = this.comlist.comtel
        from.comaddr = this.comlist.comaddr
        from.combank = this.comlist.combank
        from.combanknumber = this.comlist.combanknumber
        from.comid = this.comlist.comid
        // await this.savekpxx()
        let data = await request({
          url: '/xmgl/project/saveServicefee',
          method: "post",
          data: {
            psuid: this.psu.psuid,
            psufeepaytype: 3,
            psufeepayurl: this.psu.psufeepayurl,
            psufeepayuserid: this.$store.getters.loginUser.userid,
            from:from
          }
        })
        if (data.issuccess === 1) {
          this.$message.success('服务费支付成功')
          this.wxpush(3)
          this.loading = false
          this.close()
        } else {
          this.loading = false
          this.$message.error('服务费支付失败')
        }
      },
      close () {
        this.visible = false
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'psuServicepayIndex'})
      },
      async alipaypay(){
        if(!this.psu.psuconfirmfeeuserid){
            this.$message.warning('服务费未确认！')
            return
        }
        if(+this.psu.psufeepayflg === 1){
          this.$message.warning('已支付')
          return
        }
        // if(this.psu.psufeepayurl){
        //   this.$message.warning('凭证已上传')
        //   return
        // }
        //psuid_项目id_用户id_报名费0/保证金1/服务费2_cosid_发票
        //this.project.projectno
        let payflg = true
        let passback_params = this.psu.psuid+'_' + this.psu.psuprojectid + '_' + this.userid +'_' + 2 + '_' + this.$store.state.user.loginUser.cosid
        this.Paytype = 1
        this.order.outTradeNo = this.psu.projectno + '003' + this.userid + parseInt(Math.random()*(100+1),10)
        this.order.subject = this.psu.projectname
        this.order.totalAmount = this.psu.psuconfirmfeeamt
        this.order.passback_params = passback_params

        this.order.cosmerchantNumber = this.$store.state.user.loginUser.cosmerchantNumber
        this.order.coswxPublicAccountId = this.$store.state.user.loginUser.coswxPublicAccountId
        this.order.coswxPublicKey = this.$store.state.user.loginUser.coswxPublicKey
        this.order.coswxSecurityPrivateKey = this.$store.state.user.loginUser.coswxSecurityPrivateKey
        this.order.cosalipayApplicationId = this.$store.state.user.loginUser.cosalipayApplicationId
        this.order.cosalipayPublicKey = this.$store.state.user.loginUser.cosalipayPublicKey
        this.order.cosalipayPrivateKey = this.$store.state.user.loginUser.cosalipayPrivateKey
        this.visible = true
        this.Interval = setInterval(async () => {
            let data = await request({
              url: '/xmgl/project/searchPay',
              method: "get",
              params:{psuid : this.psuid}
            })
            if(data[0].psufeepaytradeno){
              this.wxpush(3)
              this.cacle(false)
              this.getList()
              if(payflg === true)
              this.$message.success('支付成功')
              payflg = false
              return
            }
        }, 500);
      },
      async tenpay(){
        if(!this.psu.psuconfirmfeeuserid){
            this.$message.warning('服务费未确认！')
            return
        }
        if(+this.psu.psufeepayflg === 1){
          this.$message.warning('已支付')
          return
        }
        // if(this.psu.psufeepayurl){
        //   this.$message.warning('凭证已上传')
        //   return
        // }
        let payflg = true
        let passback_params = this.psu.psuid+'_'+this.psu.psuprojectid+'_'+ this.userid + '_' + 2 + '_' + + this.$store.state.user.loginUser.cosid
        this.Paytype = 2
        this.order.outTradeNo = this.psu.projectno + '003' + this.userid + parseInt(Math.random()*(100+1),10)
        this.order.subject = this.psu.projectname
        this.order.totalAmount = this.psu.psuconfirmfeeamt * 100
        this.order.passback_params = passback_params
        this.order.body = this.psu.projectname

        this.order.cosmerchantNumber = this.$store.state.user.loginUser.cosmerchantNumber
        this.order.coswxPublicAccountId = this.$store.state.user.loginUser.coswxPublicAccountId
        this.order.coswxPublicKey = this.$store.state.user.loginUser.coswxPublicKey
        this.order.coswxSecurityPrivateKey = this.$store.state.user.loginUser.coswxSecurityPrivateKey
        this.order.cosalipayApplicationId = this.$store.state.user.loginUser.cosalipayApplicationId
        this.order.cosalipayPublicKey = this.$store.state.user.loginUser.cosalipayPublicKey
        this.order.cosalipayPrivateKey = this.$store.state.user.loginUser.cosalipayPrivateKey

        this.visible = true
        this.Interval = setInterval(async () => {
            let data = await request({
              url: '/xmgl/project/searchPay',
              method: "get",
              params:{psuid : this.psuid}
            })
            if(data[0].psufeepaytradeno){
              this.wxpush(3)
              this.cacle(false)
              this.getList()
              if(payflg === true)
              this.$message.success('支付成功')
              payflg = false
              return
            }
        }, 500);
      },
      async wxpush(type){
        let model = {}
        model.cosid = this.$store.getters.loginUser.cosid
        model.payTStype = type
        model.psuid = this.psu.psuid
        model.projectid = this.psu.projectid
        model.userid = this.psu.projectcuserid
        await request({
          url: '/info/rush/reminders',
          method: "get",
          params: model
        })
      },
    },
    destroyed(){
      clearInterval(this.Interval)
    }
  }
</script>

<style scoped lang="scss">
.el-icon-my-wechat {
    background-image: url('../../assets/image/wechat.png');
    background-size: cover;
  }

  .el-icon-my-wechat:before {
    content: "替";
    font-size: 20px;
    visibility: hidden;
  }

  .el-icon-my-zfb {
    background-image: url('../../assets/image/zfb.png');
    background-size: cover;
  }

  .el-icon-my-zfb:before {
    content: "替";
    font-size: 20px;
    visibility: hidden;
  }
.wxmessage{
  margin-top:20px;
  border: 1px solid #c8c8c8;
  width: 100%;
  font: 12px/1.5 tahoma,arial,宋体;
}
.wxmessageItem{
  display: flex;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #c8c8c8;
}
.wxmessageItem:nth-child(3){
  border-bottom: none;
}
.itemName{
  width: 100px;
  flex: 0 0 100px;
  background-color: #fbfbfb;
  border-right: 1px solid #c8c8c8;
  text-align: right;
  padding:5px;
}
.itemPrice{
  width: 650px;
  flex: 0 0 650px;
  padding:5px;
}
.priceText{
  font-size: 22px;
  color: #f60;
  font-weight: bold;
}
.split-box{
  margin: 11px 0 15px;
  .split-line{
    margin: 5px;
  }
  .split-name{
    font-weight: bold;
  }
}
</style>
